export var deliveryMethodIcons = {
    SMS: 'delivery.method.sms',
    Chat: 'delivery.method.chat',
    Email: 'delivery.method.email',
    Facebook: 'delivery.method.facebook',
    Instagram: 'delivery.method.instagram',
};
//# sourceMappingURL=delivery-method-icons.js.map